<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.5 0C9.77614 0 10 0.223858 10 0.5V5H14.5C14.7761 5 15 5.22386 15 5.5C15 5.77614 14.7761 6 14.5 6H9.5C9.22386 6 9 5.77614 9 5.5V0.5C9 0.223858 9.22386 0 9.5 0Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 0.5C1 0.223858 1.22386 0 1.5 0H9.5C9.63261 0 9.75979 0.0526784 9.85355 0.146447L14.8536 5.14645C14.9473 5.24021 15 5.36739 15 5.5V15.5C15 15.7761 14.7761 16 14.5 16H1.5C1.22386 16 1 15.7761 1 15.5V0.5ZM2 1V15H14V5.70711L9.29289 1H2Z"
      fill="currentColor"
    />
  </svg>
</template>
